export default "__VITE_ASSET__C8H8VVXH__"